import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const adaptiveStore = new Vuex.Store({
  state: {
    showDesktopAppName: null,
    ordersListOpen: null,
    showLaptopMenuButton: null,
    showHeaderInstrumentsDesktop: null,
    menuEmulationWidth: null
  },

  mutations: {
    closeOrderListUserActions (state) {
      if (document.body.clientWidth <= 425) {
        state.ordersListOpen = false
      }
    },
    showOrdersList (state) {
      state.ordersListOpen = true
      if (document.body.clientWidth > 768) {
        state.menuEmulationWidth = '366px'
      }
    },
    hideOrdersList (state) {
      state.ordersListOpen = false
      if (document.body.clientWidth > 768) {
        state.menuEmulationWidth = '74px'
      }
    },
    initStore (state) {
      let _width = document.body.clientWidth
      if (_width > 768) {
        state.showDesktopAppName = true
        state.ordersListOpen = true
        state.showHeaderInstrumentsDesktop = true
        state.showLaptopMenuButton = false
        state.menuEmulationWidth = '366px'
      } else if (_width > 425) {
        state.showDesktopAppName = false
        state.ordersListOpen = false
        state.showHeaderInstrumentsDesktop = false
        state.showLaptopMenuButton = true
        state.menuEmulationWidth = '74px'
      } else {
        state.showDesktopAppName = false
        state.ordersListOpen = true
        state.showHeaderInstrumentsDesktop = false
        state.showLaptopMenuButton = true
        state.menuEmulationWidth = '0px'
      }
    },
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },

  actions: {
    closeOrderListUserActions ({commit}) {
      commit('closeOrderListUserActions')
    },
    showOrdersList ({commit}) {
      commit('showOrdersList')
    },
    hideOrdersList ({commit}) {
      commit('hideOrdersList')
    },
    initStore ({commit}) {
      commit('initStore')
    },
    setValue ({commit}, keyValue) {
      commit('setValue', keyValue)
    }
  },

  getters: {
    value: state => key => {
      if (key in state) {
        return state[key]
      } else {
        return null
      }
    }
  }
})

export default adaptiveStore



// WEBPACK FOOTER //
// ./src/storages/adaptiveStore.js